import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LoaderComponent } from 'src/app/Shared Components/loader/loader.component';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
SnackMessageVar : string = '';
public notification$: Subject<string> = new Subject();

  constructor(private dialog :MatDialog) {
    
   }
   InvokeCloseProgressSpinner: Subject<any> = new Subject(); 
   dialogRef: MatDialogRef<MessagePopupComponent>;
   LoaderRef : MatDialogRef<LoaderComponent>;
   LoaderClose : boolean = false;
   public open(options) {
     this.dialogRef = this.dialog.open(MessagePopupComponent, {    
          data: {
            title: options.title,
            message: options.message,
            cancelText: options.cancelText,
            confirmText: options.confirmText
          }
     });  
   }

   public loader(){
    this.dialog.open(LoaderComponent);
   }
   CloseProgressSpinner(e) { 
    this.InvokeCloseProgressSpinner.next(e)      
  }

   public confirmed(): Observable<any> {
    
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
        return res;
      }
    ));
  }

   setSnackMessage(e){
     this.SnackMessageVar = e;
   }

   getSnackMessage(){
     return this.SnackMessageVar;
   }

}
